import React from 'react';
import { XMarkIcon, UserIcon, PhoneIcon, EnvelopeIcon, EyeIcon } from '@heroicons/react/24/outline';

const TeamMembersModal = ({ isOpen, onClose, team }) => {
  if (!isOpen || !team) return null;

  return (
    <div className="fixed inset-0 z-[100] overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4">
        {/* Background overlay */}
        <div
          className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
          onClick={onClose}
        ></div>

        {/* Modal panel */}
        <div className="relative bg-white rounded-lg shadow-xl max-w-4xl w-full mx-auto z-10">
          {/* Modal header */}
          <div className="bg-blue-50 px-6 py-4 border-b border-blue-200">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-lg font-semibold text-gray-900">
                  Team Members for {team.agent_id} - {team.name}
                </h3>
                <p className="mt-1 text-sm text-gray-600">
                  {team.children.length} member{team.children.length !== 1 ? 's' : ''}
                </p>
              </div>
              <button
                type="button"
                className="text-gray-400 hover:text-gray-500 focus:outline-none"
                onClick={onClose}
              >
                <span className="sr-only">Close</span>
                <XMarkIcon className="h-6 w-6" />
              </button>
            </div>
          </div>

          {/* Modal body */}
          <div className="px-6 py-5">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {team.children.map((child) => (
                <div
                  key={child.agent_id}
                  className="bg-gray-50 p-4 rounded-lg border border-gray-200 hover:shadow-md transition-shadow"
                >
                  <div className="flex items-start mb-3">
                    <div className="flex-shrink-0">
                      <UserIcon className="h-5 w-5 text-blue-600" />
                    </div>
                    <div className="ml-3 flex-1">
                      <div className="font-medium text-gray-900">{child.name}</div>
                      <div className="text-sm text-gray-500">{child.agent_id}</div>
                    </div>
                  </div>
                  <div className="space-y-2 text-sm text-gray-600">
                    <div className="flex items-center">
                      <PhoneIcon className="h-4 w-4 mr-2 text-gray-400" />
                      {child.phoneno}
                    </div>
                    <div className="flex items-center">
                      <EnvelopeIcon className="h-4 w-4 mr-2 text-gray-400" />
                      {child.email}
                    </div>
                    <div className="flex items-center">
                      <EyeIcon className="h-4 w-4 mr-2 text-gray-400" />
                      <span className="capitalize">{child.apps?.agents?.role || 'Not assigned'}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Modal footer */}
          <div className="bg-gray-50 px-6 py-4 flex justify-end">
            <button
              type="button"
              className="inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none sm:text-sm"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamMembersModal;
